import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import ContactUs from '../../Components/Entities/ContactUs/ContactUs';
import AnalyticsService from '../../Services/AnalyticsService';
import MetaTags from '../../Components/MetaTags/MetaTags';
import { isAccessingViaCustomDomain } from '../../Utils';
import useSpace from '../../Hooks/useSpace';
import ListOfUiSections from '../../Components/UiSection/ListOfUiSections';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../../Utils/NotificationUtils';

function Home() {
  const intl = useIntl();
  const { space } = useSpace();
  const notifications = useNotifications();
  const params = new URLSearchParams(window.location.search);
  const keepMeAlive = params.get('keep_me_alive');

  useEffect(() => {
    AnalyticsService.track('Space', 'Visit Space Home');

    if (keepMeAlive) {
      notify(notifications, intl.formatMessage({ id: 'KEEP_ME_ALIVE.ALERT.TITLE' }));
    }
  }, []);

  return (
    <>
      <MetaTags
        title={space.name}
        description={space.description}
        pictureUrl={space.picture_to_share_url}
        noindex={Boolean(space.custom_domain) && !isAccessingViaCustomDomain()}
      />

      {/* corresponds more or less to: 100vh - NavBar height - Footer height */}
      <Box sx={{ backgroundColor: 'grey.50', minHeight: '95vh', width: '100%' }}>
        <ListOfUiSections page="home" />

        <ContactUs space={space} />
      </Box>
    </>
  );
}

export default Home;
